var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusAlertSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4544 32.5115L21.4673 5.78914C20.8773 4.73695 19.124 4.73695 18.534 5.78914L3.54687 32.5115C3.26027 33.0292 3.26027 33.6639 3.56373 34.1816C3.86718 34.6827 4.4235 35 5.01355 35H34.9878C35.5778 35 36.1341 34.6827 36.4376 34.1816C36.741 33.6639 36.741 33.0292 36.4544 32.5115Z",
    fill: "#FEC941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6673 23.3333C21.6673 24.25 20.9173 25 20.0007 25C19.084 25 18.334 24.25 18.334 23.3333V16.6667C18.334 15.75 19.084 15 20.0007 15C20.9173 15 21.6673 15.75 21.6673 16.6667V23.3333Z",
    fill: "#0D1C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 30C19.084 30 18.334 29.25 18.334 28.3333C18.334 27.4167 19.084 26.6667 20.0007 26.6667C20.9173 26.6667 21.6673 27.4167 21.6673 28.3333C21.6673 29.25 20.9173 30 20.0007 30Z",
    fill: "#0D1C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.534 5.78914L3.54687 32.5115C3.26027 33.0292 3.26027 33.6639 3.56373 34.1816C3.86718 34.6827 4.4235 35 5.01355 35H34.9878C35.5778 35 36.1341 34.6827 36.4376 34.1816C36.741 33.6639 36.741 33.0292 36.4544 32.5115L21.4673 5.78914C20.8773 4.73695 19.124 4.73695 18.534 5.78914ZM34.9963 33.3186C34.9961 33.3183 34.9965 33.319 34.9963 33.3186L20.0512 6.67126C20.0367 6.66849 20.0195 6.66667 20.0007 6.66667C19.9818 6.66667 19.9646 6.66849 19.9501 6.67126L5.00504 33.3186C5.00484 33.319 5.00523 33.3183 5.00504 33.3186C5.00356 33.3215 5.00202 33.3253 5.00143 33.3279C5.00115 33.3277 5.00169 33.328 5.00143 33.3279C5.0084 33.3318 5.01375 33.3332 5.01469 33.3333H34.9866C34.9875 33.3332 34.9921 33.3323 34.9991 33.3283C34.9988 33.3285 34.9993 33.3282 34.9991 33.3283C34.9985 33.3258 34.9977 33.3215 34.9963 33.3186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAlertSolid);
export default __webpack_public_path__ + "static/media/status-alert-solid.6bc5604ea27f85d177a69bcb402d1a17.svg";
export { ForwardRef as ReactComponent };